import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import SideMenu from './side-menu';
import InfoSiteHelpers from 'infosite/helpers';
import MenuIcon from 'grommet/components/icons/base/Menu';
import MenuStore from './store';
import MenuActions from './actions';

import { slide as Menu} from 'react-burger-menu';

export default class MobileMenuModule extends React.Component{
    constructor(props){
        super(props);
        this.state = {};
        this.settings = props.navigation.mobile;
    }

    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    render() {
        const menuProps = {
          className: 'menu-icon-wrapper',
          onClick: (e)=>{
            e.preventDefault();
            MenuActions.toggle();
          }
        }
      if(!this.settings.image || this.settings.image.length==0){
        return (
          <div {...menuProps}><MenuIcon /></div>
        );
      }
      else{
        let url = this.props.url.startsWith('//') ? this.props.url : `${window.medscape.config.staticServer.host}${this.props.url}`;
        return (
          <a {...menuProps}><img src="{url}" /></a>
        );
      }
    }
}

MobileMenuModule.propTypes={
    "navigation": React.PropTypes.object.isRequired,
    "route": React.PropTypes.object.isRequired
}
MobileMenuModule.defaultProps={
}



// WEBPACK FOOTER //
// ./src/app/mobile-menu/app.jsx